import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ChatDashboardResponse, DashboardStatsQuery } from '@troia-v3/types';

/**
 * Hook para buscar estatísticas do chat dashboard
 * @param query Filtros opcionais (teamId, userId, startDate, endDate)
 */
export function useChatDashboard(query?: DashboardStatsQuery) {
  return useQuery({
    queryKey: ['chat-dashboard', query],
    queryFn: async () => {
      const params = new URLSearchParams();

      if (query?.teamId) params.append('teamId', query.teamId);
      if (query?.userId) params.append('userId', query.userId);
      if (query?.startDate) params.append('startDate', query.startDate);
      if (query?.endDate) params.append('endDate', query.endDate);

      const queryString = params.toString();
      const url = queryString
        ? `conversations/dashboard-stats?${queryString}`
        : 'conversations/dashboard-stats';

      const response = await api.get<{ success: boolean; data: ChatDashboardResponse }>(url);
      return response.data.data;
    },
    staleTime: 30 * 1000, // 30 segundos
    refetchInterval: 60 * 1000, // Refetch a cada 1 minuto
  });
}
